import { render, staticRenderFns } from "./ExpenseDetailsBody.vue?vue&type=template&id=e84aefc0&scoped=true&"
import script from "./ExpenseDetailsBody.vue?vue&type=script&lang=js&"
export * from "./ExpenseDetailsBody.vue?vue&type=script&lang=js&"
import style0 from "./ExpenseDetailsBody.vue?vue&type=style&index=0&id=e84aefc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e84aefc0",
  null
  
)

export default component.exports